
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/electrical-services",
      function () {
        return require("private-next-pages/electrical-services.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/electrical-services"])
      });
    }
  